var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseChip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 19.4,
    height: 19.4,
    rx: 9.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 19.4,
    height: 19.4,
    rx: 9.7,
    stroke: "#EBEBEB",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78675 9.14703L7.12106 6.48135C6.9444 6.30468 6.65796 6.30468 6.4813 6.48135C6.30463 6.65801 6.30463 6.94445 6.4813 7.12111L9.14698 9.7868C9.26476 9.90457 9.26476 10.0955 9.14698 10.2133L6.4813 12.879C6.30463 13.0557 6.30463 13.3421 6.4813 13.5188C6.65796 13.6954 6.9444 13.6954 7.12106 13.5188L9.78675 10.8531C9.90452 10.7353 10.0955 10.7353 10.2133 10.8531L12.8789 13.5188C13.0556 13.6954 13.342 13.6954 13.5187 13.5188C13.6954 13.3421 13.6954 13.0557 13.5187 12.879L10.853 10.2133C10.7352 10.0955 10.7352 9.90457 10.853 9.7868L13.5187 7.12111C13.6954 6.94445 13.6954 6.65801 13.5187 6.48135C13.342 6.30468 13.0556 6.30468 12.8789 6.48135L10.2133 9.14703C10.0955 9.26481 9.90452 9.26481 9.78675 9.14703Z",
    fill: "#FF4444",
    stroke: "#FF4444",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChip);
export default __webpack_public_path__ + "static/media/close-chip.b22e77473742c4de0e8d11546771908e.svg";
export { ForwardRef as ReactComponent };